import React, { useContext } from 'react';
import { Field, Form } from 'react-final-form';
import { useHistory, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import EmailOutlineIcon from 'mdi-react/EmailOutlineIcon';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import PasswordField from '@/shared/components/form/Password';
import {
  FormGroup,
  FormGroupField,
  FormGroupIcon,
  FormGroupLabel,
} from '@/shared/components/form/FormElements';
import { Toaster } from 'react-hot-toast';
import renderCheckBoxField from '../../form/CheckBox';
import {
  AccountButton, AccountButtons, AccountForgotPassword, LoginForm,
} from '../AccountElements';
import AuthSignUp from '../../../../utils/AuthSignIn';
import { AuthContext } from '../../../../context/AuthContext';
import { GlobalVarContext } from '../../../../context/GlobalVarContext';

const SignUpForm = ({ errorMessage }) => {
  const errorMsg = useSelector(state => state.user.error);
  const history = useHistory();
  const { 
    setIsLoggedIn, 
    setUsername, 
    setRestaurantId, 
    setUserId, 
    setStatusCode,
  } = useContext(AuthContext);
  const { apiGlobal } = useContext(GlobalVarContext);
  
  const handleSubmits = async (values) => {
    await AuthSignUp(values, history, setIsLoggedIn, setUsername, apiGlobal, setRestaurantId, setUserId, setStatusCode);
  };
  
  return (
    <Form onSubmit={handleSubmits}>
      {({ handleSubmit }) => (
        <LoginForm onSubmit={handleSubmit}>
          <Alert variant="danger" show={!!errorMessage || !!errorMsg}>
            {errorMessage}
            {errorMsg}
          </Alert>
          <FormGroup>
            <FormGroupLabel>Username</FormGroupLabel>
            <FormGroupField>
              <FormGroupIcon>
                <AccountOutlineIcon />
              </FormGroupIcon>
              <Field
                name="username"
                component="input"
                type="text"
                placeholder="Username"
                className="input-without-border-radius"
              />
            </FormGroupField>
          </FormGroup>
          <FormGroup>
            <FormGroupLabel>Email</FormGroupLabel>
            <FormGroupField>
              <FormGroupIcon>
                <EmailOutlineIcon />
              </FormGroupIcon>
              <Field
                name="email"
                component="input"
                type="email"
                placeholder="Email"
                className="input-without-border-radius"
              />
            </FormGroupField>
          </FormGroup>
          <FormGroup>
            <FormGroupLabel>Password</FormGroupLabel>
            <FormGroupField>
              <Field
                name="password"
                component={PasswordField}
                placeholder="Password"
                className="input-without-border-radius"
                keyIcon
              />
            </FormGroupField>
          </FormGroup>
          <FormGroup>
            <FormGroupLabel>Confirm Password</FormGroupLabel>
            <FormGroupField>
              <FormGroupIcon>
                <AccountOutlineIcon />
              </FormGroupIcon>
              <Field
                name="confirmPassword"
                component={PasswordField}
                placeholder="Confirm Password"
                className="input-without-border-radius"
                validate={(value, allValues) => {
                  if (!value) return 'Confirm Password is required';
                  if (value !== allValues.password) return 'Passwords do not match';
                  return undefined;
                }}
                required
              />
            </FormGroupField>
          </FormGroup>
          <FormGroup>
            <FormGroupField>
              <Field
                name="terms"
                render={renderCheckBoxField}
                label="I agree to the terms and conditions"
                type="checkbox"
              />
            </FormGroupField>
          </FormGroup>
          <AccountButtons>
            <AccountButton type="submit" variant="primary">
              Sign Up
            </AccountButton>
          </AccountButtons>
          <AccountForgotPassword>
            <NavLink to="/login">Already have an account? Log in</NavLink>
          </AccountForgotPassword>
        </LoginForm>
      )}
    </Form>
  );
};

SignUpForm.propTypes = {
  errorMessage: PropTypes.string,
};

SignUpForm.defaultProps = {
  errorMessage: '',
};

export default SignUpForm;



// import React, { useContext } from 'react';
// import { Field, Form } from 'react-final-form';
// import { useHistory, NavLink } from 'react-router-dom'; // Import useHistory
// import { useSelector } from 'react-redux';
// import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
// import PropTypes from 'prop-types';
// import { Alert } from 'react-bootstrap';
// import PasswordField from '@/shared/components/form/Password';
// import {
//   FormGroup,
//   FormGroupField,
//   FormGroupIcon,
//   FormGroupLabel,
// } from '@/shared/components/form/FormElements';
// import { Toaster } from 'react-hot-toast';
// import renderCheckBoxField from '../../form/CheckBox';
// import {
//   AccountButton, AccountButtons, AccountForgotPassword, LoginForm,
// } from '../AccountElements';
// import AuthSign from '../../../../utils/AuthSignIn'; // Import AuthSign
// import { AuthContext } from '../../../../context/AuthContext';
// import { GlobalVarContext } from '../../../../context/GlobalVarContext';


// const LogInForm = ({
//  errorMessage, fieldUser, typeFieldUser, form, 
// }) => {
//   const errorMsg = useSelector(state => state.user.error);
//   const history = useHistory(); // Use useHistory hook to get the history object
//   const { 
//     setIsLoggedIn, 
//     setUsername, 
//     setRestaurantId, 
//     setUserId, 
//     setStatusCode,
//   } = useContext(AuthContext);
//   const { apiGlobal } = useContext(GlobalVarContext);
//   const handleSubmits = async (values) => {
//     // Pass values and history to AuthSign
//     await AuthSign(values, history, setIsLoggedIn, setUsername, 
//            apiGlobal, setRestaurantId, setUserId, setStatusCode);
//   };
  
//   return (
//     <Form onSubmit={handleSubmits}>
//       {({ handleSubmit }) => (
//         <LoginForm onSubmit={handleSubmit}>
//           <Alert variant="danger" show={!!errorMessage || !!errorMsg}>
//             {errorMessage}
//             {errorMsg}
//           </Alert>
//           <FormGroup>
//             <FormGroupLabel>{fieldUser}</FormGroupLabel>
//             <FormGroupField>
//               <FormGroupIcon>
//                 <AccountOutlineIcon />
//               </FormGroupIcon>
//               <Field
//                 name="username"
//                 component="input"
//                 type={typeFieldUser}
//                 placeholder={fieldUser}
//                 className="input-without-border-radius"
//               />
//             </FormGroupField>
//           </FormGroup>
//           <FormGroup>
//             <FormGroupLabel>Password</FormGroupLabel>
//             <FormGroupField>
//               <Field
//                 name="passwords"
//                 component={PasswordField}
//                 placeholder="Password"
//                 className="input-without-border-radius"
//                 keyIcon
//               />
//               <AccountForgotPassword>
//                 <NavLink to="/forgot_password">Forgot a ssspassword?</NavLink>
//               </AccountForgotPassword>
//             </FormGroupField>
//           </FormGroup>
//           <FormGroup>
//             <FormGroupField>
//               <Field
//                 name="remember_me"
//                 render={renderCheckBoxField}
//                 label="Remember me"
//                 type="checkbox"
//               />
//             </FormGroupField>
//           </FormGroup>
//           <AccountButtons>
//             <AccountButton type="submit" variant="primary">
//               Sign Up
//             </AccountButton>
//           </AccountButtons>
//         </LoginForm>
//       )}
//     </Form>
//   );
// };

// LogInForm.propTypes = {
//   errorMessage: PropTypes.string,
//   fieldUser: PropTypes.string,
//   typeFieldUser: PropTypes.string,
//   form: PropTypes.string.isRequired,
// };

// LogInForm.defaultProps = {
//   errorMessage: '',
//   fieldUser: 'Username',
//   typeFieldUser: 'text',
// };

// export default LogInForm;


// import React, { useContext } from 'react';
// import { Field, Form } from 'react-final-form';
// import { useHistory, NavLink } from 'react-router-dom'; // Import useHistory
// import { useSelector } from 'react-redux';
// import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
// import PropTypes from 'prop-types';
// import { Alert } from 'react-bootstrap';
// import PasswordField from '@/shared/components/form/Password';
// import {
//   FormGroup,
//   FormGroupField,
//   FormGroupIcon,
//   FormGroupLabel,
// } from '@/shared/components/form/FormElements';
// import { Toaster } from 'react-hot-toast';
// import renderCheckBoxField from '../../form/CheckBox';
// import {
//   AccountButton, AccountButtons, AccountForgotPassword, LoginForm,
// } from '../AccountElements';
// import AuthSign from '../../../../utils/AuthSignIn'; // Import AuthSign
// import { AuthContext } from '../../../../context/AuthContext';
// import { GlobalVarContext } from '../../../../context/GlobalVarContext';


// const LogInForm = ({
//  errorMessage, fieldUser, typeFieldUser, form, 
// }) => {
//   const errorMsg = useSelector(state => state.user.error);
//   const history = useHistory(); // Use useHistory hook to get the history object
//   const { 
//     setIsLoggedIn, 
//     setUsername, 
//     setRestaurantId, 
//     setUserId, 
//     setStatusCode,
//   } = useContext(AuthContext);
//   const { apiGlobal } = useContext(GlobalVarContext);
//   const handleSubmits = async (values) => {
//     // Pass values and history to AuthSign
//     await AuthSign(values, history, setIsLoggedIn, setUsername, 
// apiGlobal, setRestaurantId, setUserId, setStatusCode);
//   };
  
//   return (
//     <Form onSubmit={handleSubmits}>
//       {({ handleSubmit }) => (
//         <LoginForm onSubmit={handleSubmit}>
//           <Alert variant="danger" show={!!errorMessage || !!errorMsg}>
//             {errorMessage}
//             {errorMsg}
//           </Alert>
//           <FormGroup>
//             <FormGroupLabel>{fieldUser}</FormGroupLabel>
//             <FormGroupField>
//               <FormGroupIcon>
//                 <AccountOutlineIcon />
//               </FormGroupIcon>
//               <Field
//                 name="username"
//                 component="input"
//                 type={typeFieldUser}
//                 placeholder={fieldUser}
//                 className="input-without-border-radius"
//               />
//             </FormGroupField>
//           </FormGroup>
//           <FormGroup>
//             <FormGroupLabel>Password</FormGroupLabel>
//             <FormGroupField>
//               <Field
//                 name="passwords"
//                 component={PasswordField}
//                 placeholder="Password"
//                 className="input-without-border-radius"
//                 keyIcon
//               />
//               {/* <AccountForgotPassword>
//                 <NavLink to="/forgot_password">Forgot a ssspassword?</NavLink>
//               </AccountForgotPassword> */}
//             </FormGroupField>
//             <FormGroup>
//               <FormGroupLabel>Confirm Password</FormGroupLabel>
//               <FormGroupField>
//                 <FormGroupIcon>
//                   <AccountOutlineIcon />
//                 </FormGroupIcon>
//                 <Field
//                   name="confirmPassword"
//                   component={PasswordField}
//                   placeholder="Confirm Password"
//                   className="input-without-border-radius"
//                   validate={(value, allValues) => {
//                     if (!value) return 'Confirm Password is required';
//                     if (value !== allValues.password) return 'Passwords do not match';
//                     return undefined;
//                   }}
//                   required
//                 />
//               </FormGroupField>
//             </FormGroup>
//           </FormGroup>
//           <FormGroup>
//             {/* <FormGroupField>
//               <Field
//                 name="remember_me"
//                 render={renderCheckBoxField}
//                 label="Remember me"
//                 type="checkbox"
//               />
//             </FormGroupField> */}
//           </FormGroup>
//           <AccountButtons>
//             <AccountButton type="submit" variant="primary">
//               Sign Up
//             </AccountButton>
//           </AccountButtons>
//         </LoginForm>
//       )}
//     </Form>
//   );
// };

// LogInForm.propTypes = {
//   errorMessage: PropTypes.string,
//   fieldUser: PropTypes.string,
//   typeFieldUser: PropTypes.string,
//   form: PropTypes.string.isRequired,
// };

// LogInForm.defaultProps = {
//   errorMessage: '',
//   fieldUser: 'Username',
//   typeFieldUser: 'text',
// };

// export default LogInForm;

